import Vue from 'vue';

Vue.component('m-line-bar', () => import(/* webpackChunkName: "components-echarts" */ './m-line-bar.vue'));
